import React, { PureComponent } from 'react';
import styles from './index.css';

class Content extends PureComponent {
    render() {
        return (
            <div className={styles.wxbCon}>
                <div className={styles.wxbTit}>
                    <img src={require('./wxbtit.gif')} width="1000" height="101" />
                </div>
                <div className={styles.wxbTxt}>
                    <p>为保证凤凰网互动言论平台之合法，请勿使用本平台发布如下类型信息：</p>
                    <p>(一)反对宪法所确定的基本原则的；</p>
                    <p>(二)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                    <p>(三)损害国家荣誉和利益的；</p>
                    <p>(四)煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                    <p>(五)破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                    <p>(六)散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                    <p>(七)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                    <p>(八)侮辱或者诽谤他人，侵害他们合法权益的；</p>
                    <p>(九)含有法律、行政法规禁止的其他内容的。</p>
                    <p>同时，为维护健康的网上舆论环境，我们有权对上述信息进行处理，并对发布人追究相应责任。</p>
                </div>
            </div>
        );
    }
}

export default Content;
